import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const RemarkOptionForm = ({ data, onSubmit }) => {
    const [state, setState] = useState({
        remarkOption: {
            name: 'remarkOption',
            value: data?.OPTION_NAME || '',
            isRequired: true,
            error: '',
        },
        description: {
            name: 'description',
            value: data?.DESCRIPTION || '',
            isRequired: false,
            error: '',
        },
        sortOrder: {
            name: 'sortOrder',
            value: data?.SORT_ORDER || '',
            isRequired: false,
            error: '',
        },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
                error: prev[name].isRequired && !value ? 'This field is required' : '',
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach((key) => {
                model[key] = state[key].value;
            });
            if (data?.ID) {
                model.id = data.ID;
                model.previousName = data.OPTION_NAME;
            }
            onSubmit(model);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Remark Option <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name={state.remarkOption.name}
                        value={state.remarkOption.value}
                        onChange={handleChange}
                        placeholder="Enter remark option"
                        className={`form-control ${state.remarkOption.error ? 'is-invalid' : ''}`}
                    />
                    {state.remarkOption.error && (
                        <div className="invalid-feedback">{state.remarkOption.error}</div>
                    )}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Sort Order</label>
                    <input
                        type="number"
                        min="0"
                        name={state.sortOrder.name}
                        value={state.sortOrder.value}
                        onChange={handleChange}
                        placeholder="Display order"
                        className="form-control"
                    />
                </div>

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        rows={2}
                        name={state.description.name}
                        value={state.description.value}
                        onChange={handleChange}
                        placeholder="Any additional notes"
                        className="form-control"
                    />
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a href={constant.Authedcomponent.listRemarkOptionMasterData.url} className="btn btn-danger text-white">
                    Cancel
                </a>
            </div>
        </form>
    );
};

export default RemarkOptionForm;
